import { render, staticRenderFns } from "./Breadcrumbs.vue?vue&type=template&id=67a187de"
import script from "./Breadcrumbs.vue?vue&type=script&lang=js"
export * from "./Breadcrumbs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/Companion.WebApp/ClientApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67a187de')) {
      api.createRecord('67a187de', component.options)
    } else {
      api.reload('67a187de', component.options)
    }
    module.hot.accept("./Breadcrumbs.vue?vue&type=template&id=67a187de", function () {
      api.rerender('67a187de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/application/Breadcrumbs.vue"
export default component.exports